import urlconfig, { reportProductionApi, reportStagingApi } from "../_config";

/**
 * Helper to check if organization ID matches special Staples org IDs
 * @param {number|string} orgId - The organization ID to check
 * @returns {boolean} - True if the organization is a Staples org
 */
export const isStaplesOrg = (orgId) => {
  const id = Number(orgId);
  if (!id) return false;

  // Check if we're in production or staging by comparing against config constants
  const isStaging = urlconfig.reportApi === reportStagingApi;
  const isProduction = urlconfig.reportApi === reportProductionApi;

  if (isProduction) {
    return id === 404;
  } else if (isStaging) {
    return id === 1083 || id === 1084;
  }
  return false;
};

// We can add additional orgs here for report access. 
export const isReportOrg = (orgId) => {
  const id = Number(orgId);
  if (!id) return false;
  const isStaging = urlconfig.reportApi === reportStagingApi;
  const isProduction = urlconfig.reportApi === reportProductionApi;

  if (isProduction) {
    return id === 404 || id === 405 || id === 406;
  } else if (isStaging) {
    return id === 1083 || id === 1084 || id === 406;
  }
  return id === 1083 || id === 1084 || id === 406;
};

/**
 * Helper to check if employee has special permission
 * @param {Object} permissionInfo - Object containing permissionRecords and employeeId
 * @returns {boolean} - True if employee has special permission
 */
const hasSpecialPermission = (permissionInfo) => {
  if (!permissionInfo) return false;
  const { permissionRecords, employeeId, employee } = permissionInfo;

  // Admins always have special permission
  if (employee?.account_type === 5) {
    return true;
  }

  if (!Array.isArray(permissionRecords) || !employeeId) return false;

  const record = permissionRecords.find(
    (item) => Number(item?.employee_id) === Number(employeeId)
  );
  const container = record?.updated || record?.created || record;
  const authDetails = container?.auth_details || container?.details || [];

  return authDetails.some(
    (d) =>
      d?.value === 'special_permission' ||
      d?.name === 'special_permission' ||
      d?.name_id === 'special_permission'
  );
};

/**
 * Filters out categories that have remove_from_analytics set to true (ALWAYS filtered, regardless of permissions)
 * NOTE: Access control (require_special_access/access_order) is now handled by the reducer with granular filtering
 * @param {Array} categories - Array of category objects
 * @param {Object} permissionInfo - DEPRECATED - kept for backwards compatibility but no longer used
 * @returns {Array} - Filtered array of categories
 */
export const filterStaplesOptions = (categories, permissionInfo = null) => {
  if (!Array.isArray(categories)) {
    return categories;
  }

  // NOTE: Access control filtering (require_special_access/access_order) is now handled 
  // by the reducer with granular access_order logic. We only filter remove_from_analytics here.
  return categories.filter((category) => {
    // ALWAYS filter out categories with remove_from_analytics - never show regardless of permissions
    if (category.remove_from_analytics) {
      return false;
    }

    return true;
  });
};

